export default function IconExample() {
    const decorativeIcons = ["🔒", "ɱ", "₿", "Ł", "Ð", "Ⱬ"];

    return (
        <div className="flex gap-3 justify-center items-center text-yel mb-6" aria-hidden="true">
            {decorativeIcons.map((icon, index) => (
                <span key={index} className="text-3xl leading-none" aria-hidden="true">
                    {icon}
                </span>
            ))}
        </div>
    );
}